import { render, staticRenderFns } from "./customer-code-guide.vue?vue&type=template&id=0cbdfd24&scoped=true&"
import script from "./customer-code-guide.vue?vue&type=script&lang=ts&"
export * from "./customer-code-guide.vue?vue&type=script&lang=ts&"
import style0 from "./customer-code-guide.vue?vue&type=style&index=0&id=0cbdfd24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbdfd24",
  null
  
)

export default component.exports